export const CI_RATES = {
  M_20: {
    18: [
      "0.838450",
      "0.873780",
      "0.893610",
      "0.909730",
      "0.922640",
      "0.933020",
      "0.937690",
      "0.960660",
      "0.967790",
      "0.974340",
      "0.980380",
      "0.985280",
      "0.990210",
      "0.995160",
      "1.000130",
      "1.015890",
    ],
    19: [
      "0.849160",
      "0.884900",
      "0.904720",
      "0.920020",
      "0.931930",
      "0.942220",
      "0.946930",
      "0.969750",
      "0.976670",
      "0.982970",
      "0.987890",
      "0.994300",
      "1.006150",
      "1.019910",
      "1.025010",
      "1.053110",
    ],
    20: [
      "0.859600",
      "0.895540",
      "0.914370",
      "0.928460",
      "0.940280",
      "0.950150",
      "0.954900",
      "0.977610",
      "0.984260",
      "0.989180",
      "0.994130",
      "1.012310",
      "1.017370",
      "1.021810",
      "1.059670",
      "1.102890",
    ],
    21: [
      "0.870590",
      "0.905160",
      "0.922490",
      "0.936480",
      "0.947780",
      "0.957170",
      "0.961950",
      "0.984460",
      "0.989380",
      "0.994330",
      "0.999300",
      "1.042330",
      "1.047540",
      "1.066580",
      "1.113760",
      "1.165510",
    ],
    22: [
      "0.879720",
      "0.912290",
      "0.929540",
      "0.942930",
      "0.953680",
      "0.962780",
      "0.967600",
      "0.986650",
      "0.991590",
      "0.996540",
      "1.001530",
      "1.087940",
      "1.093380",
      "1.125880",
      "1.182310",
      "1.242310",
    ],
    23: [
      "0.884470",
      "0.917050",
      "0.933700",
      "0.946520",
      "0.957010",
      "0.965770",
      "0.970600",
      "1.004450",
      "1.009470",
      "1.014520",
      "1.019590",
      "1.150960",
      "1.156720",
      "1.201430",
      "1.266740",
      "1.334720",
    ],
    24: [
      "0.887000",
      "0.918520",
      "0.934630",
      "0.947270",
      "0.957450",
      "0.980060",
      "0.991530",
      "1.036790",
      "1.053300",
      "1.069570",
      "1.074920",
      "1.155540",
      "1.223140",
      "1.294400",
      "1.368280",
      "1.443850",
    ],
    25: [
      "1.066090",
      "1.112570",
      "1.136200",
      "1.154440",
      "1.162440",
      "1.168250",
      "1.174090",
      "1.300700",
      "1.333100",
      "1.373570",
      "1.398720",
      "1.516300",
      "1.597210",
      "1.682320",
      "1.770290",
      "1.846620",
    ],
    26: [
      "1.076260",
      "1.123470",
      "1.147230",
      "1.157440",
      "1.163230",
      "1.169050",
      "1.174890",
      "1.368420",
      "1.414700",
      "1.469440",
      "1.484150",
      "1.644880",
      "1.738410",
      "1.834450",
      "1.931790",
      "2.015690",
    ],
    27: [
      "1.086340",
      "1.134090",
      "1.174310",
      "1.196010",
      "1.213080",
      "1.219150",
      "1.225240",
      "1.462600",
      "1.524470",
      "1.593490",
      "1.595180",
      "1.800100",
      "1.905210",
      "2.011170",
      "2.117480",
      "2.208950",
    ],
    28: [
      "1.093790",
      "1.155190",
      "1.216260",
      "1.252470",
      "1.285180",
      "1.291610",
      "1.298070",
      "1.587440",
      "1.664650",
      "1.746970",
      "1.755280",
      "1.983040",
      "2.098630",
      "2.214020",
      "2.329530",
      "2.428660",
    ],
    29: [
      "1.120570",
      "1.200440",
      "1.221510",
      "1.257850",
      "1.308390",
      "1.369770",
      "1.451160",
      "1.751270",
      "1.842350",
      "1.936330",
      "1.948010",
      "2.198870",
      "2.324210",
      "2.449130",
      "2.573970",
      "2.683210",
    ],
    30: [
      "1.174960",
      "1.277580",
      "1.318090",
      "1.374630",
      "1.443320",
      "1.522060",
      "1.623370",
      "1.956510",
      "2.059170",
      "2.163050",
      "2.174770",
      "2.450210",
      "2.585370",
      "2.719890",
      "2.856860",
      "2.975130",
    ],
    31: [
      "1.269540",
      "1.400930",
      "1.462410",
      "1.538110",
      "1.624860",
      "1.718570",
      "1.837790",
      "2.207620",
      "2.319830",
      "2.431560",
      "2.439970",
      "2.742810",
      "2.887710",
      "3.034830",
      "3.182920",
      "3.308520",
    ],
    32: [
      "1.423460",
      "1.587090",
      "1.666670",
      "1.759880",
      "1.860870",
      "1.966070",
      "2.099400",
      "2.511360",
      "2.630310",
      "2.747850",
      "2.750090",
      "3.082480",
      "3.240250",
      "3.398690",
      "3.556360",
      "3.688270",
    ],
    33: [
      "1.655200",
      "1.849510",
      "1.943480",
      "2.048450",
      "2.158410",
      "2.270840",
      "2.413860",
      "2.874380",
      "2.997490",
      "3.120130",
      "3.143660",
      "3.480720",
      "3.649650",
      "3.817400",
      "3.983740",
      "4.127590",
    ],
    34: [
      "1.943990",
      "2.170950",
      "2.274210",
      "2.386050",
      "2.501370",
      "2.617780",
      "2.767590",
      "3.282100",
      "3.409060",
      "3.536550",
      "3.571760",
      "3.925180",
      "4.103510",
      "4.280000",
      "4.462330",
      "4.616240",
    ],
    35: [
      "2.584850",
      "2.867940",
      "2.977900",
      "3.092630",
      "3.210350",
      "3.328910",
      "3.436090",
      "3.698020",
      "3.828560",
      "3.964230",
      "4.138420",
      "4.595740",
      "4.784610",
      "4.979850",
      "5.179010",
      "5.515530",
    ],
    36: [
      "3.034170",
      "3.347950",
      "3.457190",
      "3.570560",
      "3.685320",
      "3.801320",
      "3.901310",
      "4.186090",
      "4.324580",
      "4.466700",
      "4.651020",
      "5.149870",
      "5.356420",
      "5.566720",
      "5.789500",
      "6.164920",
    ],
    37: [
      "3.524970",
      "3.868060",
      "3.972940",
      "4.083130",
      "4.194050",
      "4.308230",
      "4.399510",
      "4.713750",
      "4.858770",
      "5.005800",
      "5.200310",
      "5.752490",
      "5.974930",
      "6.211020",
      "6.457740",
      "6.872910",
    ],
    38: [
      "4.046040",
      "4.416330",
      "4.514560",
      "4.620340",
      "4.730630",
      "4.844380",
      "4.930680",
      "5.275450",
      "5.424560",
      "5.576240",
      "5.790900",
      "6.397920",
      "6.647680",
      "6.909740",
      "7.180150",
      "7.635920",
    ],
    39: [
      "4.590870",
      "4.987830",
      "5.077940",
      "5.181830",
      "5.293060",
      "5.413680",
      "5.494200",
      "5.868770",
      "6.022310",
      "6.188630",
      "6.422310",
      "7.100360",
      "7.377790",
      "7.665430",
      "7.958870",
      "8.456110",
    ],
    40: [
      "5.145300",
      "5.569260",
      "5.655530",
      "5.759790",
      "5.879880",
      "6.007380",
      "6.081930",
      "6.487220",
      "6.657520",
      "6.837670",
      "7.102730",
      "7.855670",
      "8.161290",
      "8.473910",
      "8.789990",
      "9.327510",
    ],
    41: [
      "5.705450",
      "6.162690",
      "6.248130",
      "6.362710",
      "6.490940",
      "6.623940",
      "6.693950",
      "7.144830",
      "7.330470",
      "7.538370",
      "7.835970",
      "8.666820",
      "9.000460",
      "9.337800",
      "9.673950",
      "10.252260",
    ],
    42: [
      "6.279190",
      "6.774490",
      "6.871470",
      "6.994970",
      "7.129320",
      "7.268070",
      "7.348180",
      "7.844060",
      "8.060600",
      "8.296950",
      "8.627830",
      "9.540450",
      "9.901740",
      "10.261130",
      "10.616530",
      "11.238370",
    ],
    43: [
      "6.872720",
      "7.424160",
      "7.530220",
      "7.659670",
      "7.800070",
      "7.959450",
      "8.049500",
      "8.608880",
      "8.857140",
      "9.122010",
      "9.486150",
      "10.484050",
      "10.869760",
      "11.250350",
      "11.626370",
      "12.297080",
    ],
    44: [
      "7.514140",
      "8.120130",
      "8.230480",
      "8.365120",
      "8.528990",
      "8.706700",
      "8.825910",
      "9.451360",
      "9.730980",
      "10.023370",
      "10.420630",
      "11.504830",
      "11.913630",
      "12.316850",
      "12.717380",
      "13.462780",
    ],
    45: [
      "7.809830",
      "8.443920",
      "8.558310",
      "8.717170",
      "8.897170",
      "9.112110",
      "9.332070",
      "9.988140",
      "10.299480",
      "10.619680",
      "11.036970",
      "12.183650",
      "12.616370",
      "13.044250",
      "13.491620",
      "14.042150",
    ],
    46: [
      "8.537660",
      "9.221000",
      "9.362610",
      "9.541160",
      "9.761260",
      "10.013910",
      "10.268150",
      "10.990210",
      "11.328850",
      "11.670020",
      "12.114900",
      "13.355710",
      "13.816980",
      "14.299170",
      "14.777360",
      "15.357190",
    ],
    47: [
      "9.325430",
      "10.094660",
      "10.255260",
      "10.478590",
      "10.737220",
      "11.025730",
      "11.311740",
      "12.101140",
      "12.461330",
      "12.821030",
      "13.295160",
      "14.640800",
      "15.161650",
      "15.677280",
      "16.175820",
      "16.777960",
    ],
    48: [
      "10.219820",
      "11.068990",
      "11.279510",
      "11.543500",
      "11.837680",
      "12.157800",
      "12.471140",
      "13.325470",
      "13.704150",
      "14.083130",
      "14.591700",
      "16.084560",
      "16.641840",
      "17.179400",
      "17.689400",
      "18.311710",
    ],
    49: [
      "11.187000",
      "12.164940",
      "12.421100",
      "12.722740",
      "13.048670",
      "13.396740",
      "13.729730",
      "14.650110",
      "15.048730",
      "15.452170",
      "16.028920",
      "17.652670",
      "18.234450",
      "18.785030",
      "19.303560",
      "19.941940",
    ],
    50: [
      "12.305060",
      "13.412730",
      "13.707580",
      "14.040280",
      "14.392570",
      "14.758530",
      "15.104100",
      "16.096160",
      "16.519940",
      "16.983980",
      "17.606610",
      "19.355570",
      "19.951260",
      "20.511010",
      "21.032550",
      "21.692480",
    ],
    51: [
      "13.620360",
      "14.855590",
      "15.176380",
      "15.531590",
      "15.896870",
      "16.272930",
      "16.624030",
      "17.699370",
      "18.188220",
      "18.685130",
      "19.341500",
      "21.212210",
      "21.816840",
      "22.378940",
      "22.907480",
      "23.590030",
    ],
    52: [
      "15.172200",
      "16.529100",
      "16.860950",
      "17.221380",
      "17.590650",
      "17.972550",
      "18.323960",
      "19.536260",
      "20.057300",
      "20.570490",
      "21.249980",
      "23.246280",
      "23.851620",
      "24.420110",
      "24.954730",
      "25.664010",
    ],
    53: [
      "16.891330",
      "18.369460",
      "18.695300",
      "19.054430",
      "19.429150",
      "19.824070",
      "20.221780",
      "21.543850",
      "22.080050",
      "22.596890",
      "23.296930",
      "25.419280",
      "26.030420",
      "26.605250",
      "27.149040",
      "27.886730",
    ],
    54: [
      "18.817920",
      "20.404120",
      "20.711980",
      "21.068110",
      "21.455260",
      "21.917410",
      "22.319000",
      "23.740530",
      "24.275730",
      "24.790450",
      "25.505180",
      "27.770960",
      "28.385640",
      "28.969620",
      "29.522060",
      "30.288610",
    ],
    55: [
      "20.820600",
      "22.517360",
      "22.814710",
      "23.182640",
      "23.648280",
      "24.144020",
      "25.002610",
      "26.046670",
      "26.577020",
      "27.083050",
      "27.821560",
      "30.239740",
      "30.864570",
      "31.457510",
      "32.018280",
      "32.812240",
    ],
  },
  M_60: {
    18: [
      "1.06579",
      "1.11764",
      "1.13825",
      "1.15473",
      "1.16846",
      "1.18021",
      "1.18280",
      "1.21103",
      "1.21959",
      "1.22761",
      "1.23520",
      "1.24138",
      "1.24282",
      "1.25928",
      "1.28309",
      "1.31413",
    ],
    19: [
      "1.06895",
      "1.12118",
      "1.14188",
      "1.15844",
      "1.17215",
      "1.18395",
      "1.18659",
      "1.21490",
      "1.22350",
      "1.23153",
      "1.23769",
      "1.24467",
      "1.26226",
      "1.28813",
      "1.32193",
      "1.36234",
    ],
    20: [
      "1.07232",
      "1.12480",
      "1.14560",
      "1.16214",
      "1.17592",
      "1.18779",
      "1.19058",
      "1.21901",
      "1.22763",
      "1.23377",
      "1.23993",
      "1.26456",
      "1.29269",
      "1.32959",
      "1.37364",
      "1.42411",
    ],
    21: [
      "1.07574",
      "1.12851",
      "1.14930",
      "1.16593",
      "1.17979",
      "1.19165",
      "1.19442",
      "1.22292",
      "1.22904",
      "1.23518",
      "1.24136",
      "1.29651",
      "1.33690",
      "1.38507",
      "1.44009",
      "1.50075",
    ],
    22: [
      "1.07921",
      "1.13205",
      "1.15293",
      "1.16964",
      "1.18348",
      "1.19539",
      "1.19814",
      "1.22304",
      "1.22915",
      "1.23530",
      "1.24148",
      "1.34346",
      "1.39632",
      "1.45651",
      "1.52260",
      "1.59336",
    ],
    23: [
      "1.08274",
      "1.13566",
      "1.15665",
      "1.17334",
      "1.18725",
      "1.19923",
      "1.20654",
      "1.22554",
      "1.23166",
      "1.23782",
      "1.26790",
      "1.40736",
      "1.47343",
      "1.54567",
      "1.62271",
      "1.70344",
    ],
    24: [
      "1.08633",
      "1.13937",
      "1.16035",
      "1.17713",
      "1.19112",
      "1.20522",
      "1.22266",
      "1.23148",
      "1.24760",
      "1.28569",
      "1.33237",
      "1.49073",
      "1.56997",
      "1.65407",
      "1.74186",
      "1.83189",
    ],
    25: [
      "1.41367",
      "1.47502",
      "1.50770",
      "1.53369",
      "1.54692",
      "1.55466",
      "1.56243",
      "1.57024",
      "1.57809",
      "1.58598",
      "1.60341",
      "1.79272",
      "1.88673",
      "1.98633",
      "2.08911",
      "2.19455",
    ],
    26: [
      "1.41805",
      "1.47969",
      "1.51252",
      "1.55338",
      "1.57731",
      "1.58519",
      "1.59312",
      "1.59827",
      "1.60626",
      "1.64618",
      "1.71753",
      "1.93144",
      "2.04071",
      "2.15284",
      "2.26732",
      "2.38306",
    ],
    27: [
      "1.42248",
      "1.48447",
      "1.53258",
      "1.57307",
      "1.60769",
      "1.61573",
      "1.62381",
      "1.62630",
      "1.69684",
      "1.77601",
      "1.86165",
      "2.10127",
      "2.22385",
      "2.34835",
      "2.47372",
      "2.60118",
    ],
    28: [
      "1.42697",
      "1.50492",
      "1.55265",
      "1.59275",
      "1.63808",
      "1.64627",
      "1.67842",
      "1.75731",
      "1.84514",
      "1.93934",
      "2.03841",
      "2.30363",
      "2.43924",
      "2.57523",
      "2.71298",
      "2.85271",
    ],
    29: [
      "1.45167",
      "1.55145",
      "1.57271",
      "1.61244",
      "1.66847",
      "1.73774",
      "1.83102",
      "1.92824",
      "2.03184",
      "2.13995",
      "2.25022",
      "2.54246",
      "2.69016",
      "2.83919",
      "2.98986",
      "3.14626",
    ],
    30: [
      "1.50972",
      "1.63557",
      "1.68002",
      "1.74291",
      "1.82087",
      "1.91116",
      "2.02947",
      "2.14319",
      "2.26098",
      "2.38047",
      "2.50100",
      "2.82186",
      "2.98319",
      "3.14573",
      "3.31406",
      "3.48578",
    ],
    31: [
      "1.61480",
      "1.77495",
      "1.84376",
      "1.92966",
      "2.02954",
      "2.13869",
      "2.27962",
      "2.40746",
      "2.53647",
      "2.66601",
      "2.79577",
      "3.14980",
      "3.32513",
      "3.50629",
      "3.69066",
      "3.87529",
    ],
    32: [
      "1.79088",
      "1.98844",
      "2.07873",
      "2.18621",
      "2.30413",
      "2.42827",
      "2.58818",
      "2.72645",
      "2.86481",
      "3.00289",
      "3.14285",
      "3.53345",
      "3.72828",
      "3.92613",
      "4.12378",
      "4.32062",
    ],
    33: [
      "2.05997",
      "2.29368",
      "2.40168",
      "2.52437",
      "2.65461",
      "2.78918",
      "2.96178",
      "3.10782",
      "3.25323",
      "3.40059",
      "3.55042",
      "3.98729",
      "4.19920",
      "4.41045",
      "4.62046",
      "4.83542",
    ],
    34: [
      "2.39637",
      "2.66918",
      "2.78976",
      "2.92265",
      "3.06138",
      "3.20177",
      "3.38459",
      "3.53664",
      "3.69084",
      "3.84769",
      "4.01287",
      "4.49730",
      "4.72313",
      "4.94719",
      "5.17638",
      "5.40634",
    ],
    35: [
      "3.16206",
      "3.50299",
      "3.63444",
      "3.77322",
      "3.91594",
      "4.06104",
      "4.19402",
      "4.28119",
      "4.44645",
      "4.62138",
      "4.80237",
      "5.35681",
      "5.60060",
      "5.84996",
      "6.09988",
      "6.35939",
    ],
    36: [
      "3.69266",
      "4.07291",
      "4.20619",
      "4.34466",
      "4.48621",
      "4.63064",
      "4.75985",
      "4.84390",
      "5.02519",
      "5.21319",
      "5.40337",
      "6.01001",
      "6.27564",
      "6.54158",
      "6.81727",
      "7.10047",
    ],
    37: [
      "4.27722",
      "4.69576",
      "4.82514",
      "4.96214",
      "5.10129",
      "5.24795",
      "5.37224",
      "5.46013",
      "5.65490",
      "5.85239",
      "6.05130",
      "6.72240",
      "7.00569",
      "7.29945",
      "7.60102",
      "7.90778",
    ],
    38: [
      "4.90441",
      "5.35771",
      "5.48174",
      "5.61587",
      "5.75838",
      "5.90881",
      "6.03600",
      "6.12409",
      "6.32827",
      "6.53476",
      "6.75165",
      "7.48617",
      "7.79961",
      "8.12150",
      "8.44884",
      "8.77876",
    ],
    39: [
      "5.56660",
      "6.05578",
      "6.17263",
      "6.30939",
      "6.45741",
      "6.62306",
      "6.75053",
      "6.83377",
      "7.04634",
      "7.27197",
      "7.50271",
      "8.31819",
      "8.66177",
      "9.01166",
      "9.36409",
      "9.71668",
    ],
    40: [
      "6.24914",
      "6.77494",
      "6.89284",
      "7.03508",
      "7.20149",
      "7.38088",
      "7.50606",
      "7.58335",
      "7.81642",
      "8.05655",
      "8.31412",
      "9.21509",
      "9.58894",
      "9.96635",
      "10.34360",
      "10.71687",
    ],
    41: [
      "6.94726",
      "7.52192",
      "7.64458",
      "7.80825",
      "7.99035",
      "8.17902",
      "8.30266",
      "8.38684",
      "8.63590",
      "8.90507",
      "9.19011",
      "10.18053",
      "10.58446",
      "10.98909",
      "11.38911",
      "11.78253",
    ],
    42: [
      "7.67406",
      "8.30439",
      "8.45177",
      "8.63290",
      "8.82522",
      "9.02243",
      "9.15897",
      "9.24396",
      "9.52542",
      "9.82454",
      "10.13725",
      "11.22115",
      "11.65509",
      "12.08466",
      "12.50683",
      "12.92191",
    ],
    43: [
      "8.43982",
      "9.15415",
      "9.32008",
      "9.51115",
      "9.71283",
      "9.93374",
      "10.07666",
      "10.17994",
      "10.49433",
      "10.82368",
      "11.16345",
      "12.34541",
      "12.80683",
      "13.26077",
      "13.70678",
      "14.14768",
    ],
    44: [
      "9.29455",
      "10.08770",
      "10.26052",
      "10.45913",
      "10.68676",
      "10.92422",
      "11.09151",
      "11.21139",
      "11.55820",
      "11.91660",
      "12.28267",
      "13.56542",
      "14.05338",
      "14.53333",
      "15.00767",
      "15.50270",
    ],
    45: [
      "9.74312",
      "10.57488",
      "10.75091",
      "10.97348",
      "11.21293",
      "11.48830",
      "11.76841",
      "11.92529",
      "12.30434",
      "12.69068",
      "13.07873",
      "14.43770",
      "14.95215",
      "15.45936",
      "15.98857",
      "16.51358",
    ],
    46: [
      "10.74976",
      "11.64649",
      "11.84825",
      "12.08436",
      "12.36165",
      "12.67270",
      "12.98098",
      "13.14746",
      "13.55508",
      "13.96490",
      "14.37415",
      "15.84457",
      "16.39238",
      "16.96447",
      "17.53116",
      "18.07908",
    ],
    47: [
      "11.84286",
      "12.84178",
      "13.05237",
      "13.32917",
      "13.64269",
      "13.98738",
      "14.32084",
      "14.49220",
      "14.92364",
      "15.35513",
      "15.78682",
      "17.38149",
      "18.00101",
      "18.61437",
      "19.20640",
      "19.76784",
    ],
    48: [
      "13.06703",
      "14.15342",
      "14.40676",
      "14.72078",
      "15.06742",
      "15.44176",
      "15.79640",
      "15.96476",
      "16.41800",
      "16.87263",
      "17.33233",
      "19.10232",
      "19.76739",
      "20.40850",
      "21.01551",
      "21.58683",
    ],
    49: [
      "14.34724",
      "15.57641",
      "15.87179",
      "16.22224",
      "16.60008",
      "17.00286",
      "17.37433",
      "17.53788",
      "18.01630",
      "18.50169",
      "19.03083",
      "20.95751",
      "21.65442",
      "22.31312",
      "22.93231",
      "23.50137",
    ],
    50: [
      "15.76887",
      "17.14592",
      "17.47917",
      "17.86173",
      "18.26802",
      "18.69231",
      "19.07614",
      "19.23526",
      "19.74664",
      "20.30916",
      "20.88183",
      "22.95857",
      "23.67567",
      "24.34861",
      "24.96600",
      "25.53649",
    ],
    51: [
      "17.39381",
      "18.91974",
      "19.27998",
      "19.68800",
      "20.11274",
      "20.55272",
      "20.94363",
      "21.10210",
      "21.69814",
      "22.30722",
      "22.90783",
      "25.13062",
      "25.86331",
      "26.53412",
      "27.15327",
      "27.72118",
    ],
    52: [
      "19.26459",
      "20.93608",
      "21.31084",
      "21.73001",
      "22.16636",
      "22.62054",
      "23.01653",
      "23.22685",
      "23.87172",
      "24.50911",
      "25.12421",
      "27.49886",
      "28.22836",
      "28.90097",
      "29.51716",
      "30.08420",
    ],
    53: [
      "21.31108",
      "23.13181",
      "23.50790",
      "23.93406",
      "24.38538",
      "24.86431",
      "25.33010",
      "25.54897",
      "26.22307",
      "26.87492",
      "27.50056",
      "30.01651",
      "30.74778",
      "31.41770",
      "32.03377",
      "32.59997",
    ],
    54: [
      "23.60779",
      "25.56931",
      "25.93512",
      "26.36753",
      "26.84265",
      "27.41739",
      "27.90593",
      "28.10349",
      "28.78908",
      "29.44957",
      "30.06591",
      "32.74062",
      "33.46663",
      "34.13603",
      "34.75128",
      "35.31561",
    ],
    55: [
      "26.02011",
      "28.12907",
      "28.49369",
      "28.95028",
      "29.53506",
      "30.16646",
      "31.24438",
      "31.95328",
      "32.64113",
      "33.28399",
      "33.89273",
      "36.80501",
      "37.53283",
      "38.20230",
      "38.81678",
      "39.37839",
    ],
  },
  F_20: {
    18: [
      "0.79140",
      "0.81051",
      "0.82580",
      "0.83806",
      "0.84772",
      "0.85587",
      "0.87765",
      "0.89825",
      "0.90416",
      "0.90954",
      "0.91451",
      "0.91908",
      "0.92131",
      "0.93189",
      "0.94508",
      "0.96066",
    ],
    19: [
      "0.79812",
      "0.81700",
      "0.83280",
      "0.84475",
      "0.85450",
      "0.86294",
      "0.88425",
      "0.90494",
      "0.91076",
      "0.91605",
      "0.92063",
      "0.92555",
      "0.93666",
      "0.95078",
      "0.96757",
      "0.98715",
    ],
    20: [
      "0.80322",
      "0.82213",
      "0.83745",
      "0.84943",
      "0.85945",
      "0.86797",
      "0.89006",
      "0.91071",
      "0.91639",
      "0.92098",
      "0.92558",
      "0.94060",
      "0.95574",
      "0.97388",
      "0.99509",
      "1.01896",
    ],
    21: [
      "0.80640",
      "0.82631",
      "0.84154",
      "0.85376",
      "0.86380",
      "0.87214",
      "0.89505",
      "0.91558",
      "0.92016",
      "0.92476",
      "0.92938",
      "0.95954",
      "0.97925",
      "1.00231",
      "1.02825",
      "1.05685",
    ],
    22: [
      "0.81012",
      "0.83009",
      "0.84556",
      "0.85776",
      "0.86755",
      "0.87569",
      "0.90010",
      "0.91830",
      "0.92289",
      "0.92750",
      "0.93214",
      "0.98426",
      "1.00941",
      "1.03767",
      "1.06876",
      "1.10236",
    ],
    23: [
      "0.81387",
      "0.83341",
      "0.84883",
      "0.86069",
      "0.87021",
      "0.87794",
      "0.90824",
      "0.92305",
      "0.92767",
      "0.93231",
      "0.93697",
      "1.01635",
      "1.04725",
      "1.08114",
      "1.11765",
      "1.15657",
    ],
    24: [
      "0.81807",
      "0.83787",
      "0.85297",
      "0.86460",
      "0.87370",
      "0.87806",
      "0.92161",
      "0.93180",
      "0.93646",
      "0.94621",
      "0.96678",
      "1.05754",
      "1.09457",
      "1.13434",
      "1.17660",
      "1.22038",
    ],
    25: [
      "1.06818",
      "1.08888",
      "1.11219",
      "1.12980",
      "1.13895",
      "1.14464",
      "1.15037",
      "1.27622",
      "1.28941",
      "1.30606",
      "1.35854",
      "1.36922",
      "1.40892",
      "1.45259",
      "1.49902",
      "1.53614",
    ],
    26: [
      "1.07708",
      "1.09841",
      "1.12126",
      "1.13279",
      "1.16723",
      "1.17307",
      "1.17894",
      "1.31583",
      "1.33466",
      "1.35757",
      "1.40477",
      "1.43832",
      "1.48658",
      "1.53751",
      "1.59140",
      "1.63398",
    ],
    27: [
      "1.08465",
      "1.10689",
      "1.12213",
      "1.16207",
      "1.20293",
      "1.20895",
      "1.21499",
      "1.36632",
      "1.39220",
      "1.42233",
      "1.46388",
      "1.52265",
      "1.57870",
      "1.63767",
      "1.69773",
      "1.74534",
    ],
    28: [
      "1.09353",
      "1.12568",
      "1.13325",
      "1.18968",
      "1.22546",
      "1.23988",
      "1.27833",
      "1.43289",
      "1.46664",
      "1.50464",
      "1.54089",
      "1.62437",
      "1.68896",
      "1.75442",
      "1.82028",
      "1.87140",
    ],
    29: [
      "1.11727",
      "1.15992",
      "1.16508",
      "1.21729",
      "1.24799",
      "1.27082",
      "1.28170",
      "1.52088",
      "1.56291",
      "1.60897",
      "1.64217",
      "1.74750",
      "1.81888",
      "1.89027",
      "1.96040",
      "2.01403",
    ],
    30: [
      "1.27596",
      "1.33373",
      "1.34758",
      "1.36938",
      "1.39757",
      "1.43194",
      "1.51324",
      "1.79666",
      "1.85195",
      "1.91011",
      "1.94438",
      "2.08189",
      "2.16704",
      "2.25026",
      "2.33083",
      "2.39158",
    ],
    31: [
      "1.34706",
      "1.41682",
      "1.43802",
      "1.46776",
      "1.50400",
      "1.54707",
      "1.64333",
      "1.95124",
      "2.01388",
      "2.07962",
      "2.11541",
      "2.26738",
      "2.35708",
      "2.44351",
      "2.52671",
      "2.58759",
    ],
    32: [
      "1.45105",
      "1.53220",
      "1.56101",
      "1.59798",
      "1.64245",
      "1.69370",
      "1.80416",
      "2.13977",
      "2.20971",
      "2.28058",
      "2.32125",
      "2.48057",
      "2.57303",
      "2.66151",
      "2.74571",
      "2.80672",
    ],
    33: [
      "1.59372",
      "1.68794",
      "1.72262",
      "1.76628",
      "1.81791",
      "1.87621",
      "1.99850",
      "2.36846",
      "2.44255",
      "2.51671",
      "2.56696",
      "2.72390",
      "2.81772",
      "2.90642",
      "2.99171",
      "3.05302",
    ],
    34: [
      "1.75840",
      "1.86543",
      "1.90686",
      "1.95747",
      "2.01628",
      "2.07937",
      "2.21543",
      "2.62062",
      "2.69762",
      "2.77308",
      "2.83572",
      "2.98473",
      "3.07843",
      "3.16803",
      "3.25523",
      "3.31792",
    ],
    35: [
      "2.19769",
      "2.32866",
      "2.37792",
      "2.43747",
      "2.50045",
      "2.56789",
      "2.67930",
      "2.86693",
      "2.94477",
      "3.01997",
      "3.12046",
      "3.40363",
      "3.49752",
      "3.58869",
      "3.67922",
      "3.86302",
    ],
    36: [
      "2.44253",
      "2.59080",
      "2.64642",
      "2.70937",
      "2.77769",
      "2.84712",
      "2.96346",
      "3.16276",
      "3.23920",
      "3.31264",
      "3.41342",
      "3.71359",
      "3.80880",
      "3.90301",
      "3.99749",
      "4.19701",
    ],
    37: [
      "2.72061",
      "2.88715",
      "2.94449",
      "3.01224",
      "3.08205",
      "3.15162",
      "3.26881",
      "3.47870",
      "3.55257",
      "3.62240",
      "3.72453",
      "4.04395",
      "4.14204",
      "4.24037",
      "4.34150",
      "4.55975",
    ],
    38: [
      "3.03686",
      "3.21594",
      "3.27651",
      "3.34406",
      "3.41338",
      "3.48088",
      "3.59451",
      "3.81512",
      "3.88400",
      "3.95109",
      "4.05581",
      "4.39746",
      "4.49907",
      "4.60427",
      "4.71455",
      "4.95268",
    ],
    39: [
      "3.37968",
      "3.57566",
      "3.63343",
      "3.69862",
      "3.76474",
      "3.82828",
      "3.93571",
      "4.16662",
      "4.23163",
      "4.29672",
      "4.40591",
      "4.77150",
      "4.87992",
      "4.99419",
      "5.11395",
      "5.37524",
    ],
    40: [
      "3.75242",
      "3.95938",
      "4.01169",
      "4.07129",
      "4.13148",
      "4.19007",
      "4.28838",
      "4.53253",
      "4.59469",
      "4.65964",
      "4.77479",
      "5.16860",
      "5.28665",
      "5.41054",
      "5.54195",
      "5.82680",
    ],
    41: [
      "4.14352",
      "4.35880",
      "4.40205",
      "4.45308",
      "4.50651",
      "4.55827",
      "4.65069",
      "4.91101",
      "4.97230",
      "5.03833",
      "5.16265",
      "5.58910",
      "5.71674",
      "5.85327",
      "5.99555",
      "6.30706",
    ],
    42: [
      "4.54403",
      "4.76387",
      "4.79485",
      "4.83672",
      "4.88144",
      "4.92839",
      "5.01995",
      "5.29861",
      "5.36102",
      "5.43175",
      "5.56834",
      "6.02938",
      "6.17043",
      "6.31879",
      "6.47475",
      "6.81315",
    ],
    43: [
      "4.94129",
      "5.16277",
      "5.18151",
      "5.21230",
      "5.25120",
      "5.29613",
      "5.39118",
      "5.68972",
      "5.75813",
      "5.83788",
      "5.98798",
      "6.48899",
      "6.64346",
      "6.80677",
      "6.97676",
      "7.34384",
    ],
    44: [
      "5.33534",
      "5.55831",
      "5.56208",
      "5.58523",
      "5.62154",
      "5.66777",
      "5.76868",
      "6.09154",
      "6.17062",
      "6.26103",
      "6.42834",
      "6.97099",
      "7.14249",
      "7.32141",
      "7.50716",
      "7.90830",
    ],
    45: [
      "5.42569",
      "5.64366",
      "5.64370",
      "5.66690",
      "5.70626",
      "5.75689",
      "5.89973",
      "6.22879",
      "6.32439",
      "6.43356",
      "6.61531",
      "7.19323",
      "7.38661",
      "7.58656",
      "7.79639",
      "8.08070",
    ],
    46: [
      "5.75873",
      "5.98258",
      "6.01452",
      "6.04459",
      "6.05260",
      "6.11344",
      "6.27674",
      "6.63551",
      "6.74900",
      "6.87399",
      "7.07659",
      "7.70294",
      "7.91660",
      "8.14113",
      "8.37655",
      "8.68880",
    ],
    47: [
      "6.07549",
      "6.31318",
      "6.31619",
      "6.35083",
      "6.40909",
      "6.48543",
      "6.67283",
      "7.06649",
      "7.19797",
      "7.34259",
      "7.56660",
      "8.24573",
      "8.48681",
      "8.74035",
      "9.00170",
      "9.34318",
    ],
    48: [
      "6.39004",
      "6.64988",
      "6.66308",
      "6.71371",
      "6.79080",
      "6.88380",
      "7.10371",
      "7.53232",
      "7.68588",
      "7.85001",
      "8.09792",
      "8.83874",
      "9.11263",
      "9.39485",
      "9.68328",
      "10.06003",
    ],
    49: [
      "6.72390",
      "7.01134",
      "7.04373",
      "7.11678",
      "7.21322",
      "7.32727",
      "7.58143",
      "8.05012",
      "8.22483",
      "8.41061",
      "8.68825",
      "9.49924",
      "9.80511",
      "10.11644",
      "10.43842",
      "10.85181",
    ],
    50: [
      "7.09265",
      "7.41990",
      "7.47847",
      "7.57354",
      "7.69395",
      "7.82702",
      "8.12136",
      "8.63068",
      "8.82842",
      "9.04130",
      "9.35318",
      "10.23872",
      "10.57610",
      "10.92399",
      "11.27980",
      "11.73135",
    ],
    51: [
      "7.53496",
      "7.91125",
      "7.99283",
      "8.11380",
      "8.25389",
      "8.40842",
      "8.74220",
      "9.29601",
      "9.52234",
      "9.76603",
      "10.11207",
      "11.07572",
      "11.45174",
      "11.83657",
      "12.22668",
      "12.71387",
    ],
    52: [
      "8.07072",
      "8.49399",
      "8.60246",
      "8.74309",
      "8.90485",
      "9.07847",
      "9.45112",
      "10.06040",
      "10.31870",
      "10.59190",
      "10.97167",
      "12.02690",
      "12.44272",
      "12.86450",
      "13.28502",
      "13.80332",
    ],
    53: [
      "8.70593",
      "9.18467",
      "9.31091",
      "9.47304",
      "9.65272",
      "9.84509",
      "10.26421",
      "10.93699",
      "11.22517",
      "11.52614",
      "11.94715",
      "13.10127",
      "13.55741",
      "14.01176",
      "14.45666",
      "15.00058",
    ],
    54: [
      "9.45505",
      "9.98183",
      "10.12759",
      "10.30608",
      "10.50308",
      "10.72135",
      "11.19232",
      "11.93026",
      "12.24688",
      "12.58264",
      "13.04635",
      "14.30719",
      "14.79847",
      "15.27874",
      "15.74082",
      "16.30281",
    ],
    55: [
      "10.31924",
      "10.89966",
      "11.05735",
      "11.25086",
      "11.47319",
      "11.72179",
      "12.47431",
      "13.04914",
      "13.40202",
      "13.77249",
      "14.28066",
      "15.65040",
      "16.16922",
      "16.66733",
      "17.13702",
      "17.71502",
    ],
  },
  F_60: {
    18: [
      "0.99748",
      "1.02448",
      "1.04114",
      "1.05404",
      "1.06447",
      "1.07318",
      "1.12096",
      "1.14591",
      "1.15225",
      "1.15804",
      "1.16383",
      "1.17476",
      "1.18679",
      "1.20149",
      "1.21904",
      "1.23925",
    ],
    19: [
      "1.00817",
      "1.03562",
      "1.05249",
      "1.06555",
      "1.07605",
      "1.08488",
      "1.13302",
      "1.15825",
      "1.16469",
      "1.17058",
      "1.17643",
      "1.19370",
      "1.20939",
      "1.22828",
      "1.25009",
      "1.27485",
    ],
    20: [
      "1.01880",
      "1.04681",
      "1.06390",
      "1.07704",
      "1.08768",
      "1.09665",
      "1.14509",
      "1.17062",
      "1.17715",
      "1.18304",
      "1.18895",
      "1.21680",
      "1.23715",
      "1.26072",
      "1.28752",
      "1.31724",
    ],
    21: [
      "1.02985",
      "1.05806",
      "1.07524",
      "1.08857",
      "1.09937",
      "1.10846",
      "1.15717",
      "1.18299",
      "1.18891",
      "1.19485",
      "1.20083",
      "1.24542",
      "1.27094",
      "1.30004",
      "1.33225",
      "1.36736",
    ],
    22: [
      "1.04070",
      "1.06908",
      "1.08647",
      "1.09995",
      "1.11089",
      "1.12010",
      "1.16927",
      "1.19238",
      "1.19834",
      "1.20433",
      "1.21035",
      "1.28062",
      "1.31228",
      "1.34730",
      "1.38540",
      "1.42632",
    ],
    23: [
      "1.05150",
      "1.08014",
      "1.09773",
      "1.11137",
      "1.12245",
      "1.13178",
      "1.18491",
      "1.20375",
      "1.20977",
      "1.21581",
      "1.22189",
      "1.32438",
      "1.36256",
      "1.40403",
      "1.44842",
      "1.49549",
    ],
    24: [
      "1.06225",
      "1.09123",
      "1.10902",
      "1.12284",
      "1.13406",
      "1.13973",
      "1.20586",
      "1.21933",
      "1.22543",
      "1.23626",
      "1.26169",
      "1.37781",
      "1.42307",
      "1.47138",
      "1.52243",
      "1.57545",
    ],
    25: [
      "1.39218",
      "1.42263",
      "1.45123",
      "1.47342",
      "1.48514",
      "1.49257",
      "1.50003",
      "1.50753",
      "1.51507",
      "1.52265",
      "1.53026",
      "1.63207",
      "1.68193",
      "1.73597",
      "1.79325",
      "1.85373",
    ],
    26: [
      "1.40597",
      "1.43707",
      "1.46601",
      "1.48085",
      "1.48825",
      "1.49569",
      "1.50317",
      "1.51069",
      "1.51824",
      "1.53259",
      "1.56735",
      "1.71433",
      "1.77355",
      "1.83598",
      "1.90162",
      "1.96864",
    ],
    27: [
      "1.42032",
      "1.45158",
      "1.47149",
      "1.52105",
      "1.53472",
      "1.54854",
      "1.55629",
      "1.56407",
      "1.57097",
      "1.60929",
      "1.65220",
      "1.81435",
      "1.88256",
      "1.95393",
      "2.02648",
      "2.09989",
    ],
    28: [
      "1.43467",
      "1.47782",
      "1.48845",
      "1.55439",
      "1.57368",
      "1.59518",
      "1.60316",
      "1.61496",
      "1.65719",
      "1.70425",
      "1.75543",
      "1.93353",
      "2.01129",
      "2.08996",
      "2.16927",
      "2.24828",
    ],
    29: [
      "1.46444",
      "1.52040",
      "1.52535",
      "1.58773",
      "1.61264",
      "1.64182",
      "1.66657",
      "1.71311",
      "1.76456",
      "1.82040",
      "1.87932",
      "2.07496",
      "2.16042",
      "2.24619",
      "2.33122",
      "2.41455",
    ],
    30: [
      "1.66678",
      "1.74132",
      "1.75714",
      "1.78318",
      "1.81676",
      "1.85730",
      "1.95762",
      "2.01927",
      "2.08605",
      "2.15612",
      "2.22980",
      "2.46371",
      "2.56583",
      "2.66656",
      "2.76492",
      "2.86046",
    ],
    31: [
      "1.75153",
      "1.84127",
      "1.86647",
      "1.90200",
      "1.94492",
      "1.99575",
      "2.11366",
      "2.18564",
      "2.26100",
      "2.34015",
      "2.42046",
      "2.67400",
      "2.78253",
      "2.88799",
      "2.99016",
      "3.08773",
    ],
    32: [
      "1.87670",
      "1.98097",
      "2.01526",
      "2.05932",
      "2.11172",
      "2.17199",
      "2.30712",
      "2.38731",
      "2.47151",
      "2.55684",
      "2.64290",
      "2.91600",
      "3.02889",
      "3.13797",
      "3.24179",
      "3.34219",
    ],
    33: [
      "2.05218",
      "2.17194",
      "2.21291",
      "2.26443",
      "2.32481",
      "2.39306",
      "2.54269",
      "2.63103",
      "2.72039",
      "2.81079",
      "2.90042",
      "3.19244",
      "3.30823",
      "3.41829",
      "3.52451",
      "3.62834",
    ],
    34: [
      "2.25280",
      "2.38839",
      "2.43691",
      "2.49615",
      "2.56451",
      "2.63913",
      "2.80518",
      "2.89847",
      "2.99282",
      "3.08657",
      "3.17787",
      "3.48923",
      "3.60565",
      "3.71792",
      "3.82756",
      "3.93508",
    ],
    35: [
      "2.80160",
      "2.96556",
      "3.02239",
      "3.09174",
      "3.16639",
      "3.24614",
      "3.37938",
      "3.41321",
      "3.50962",
      "3.60356",
      "3.69494",
      "4.03755",
      "4.15616",
      "4.27170",
      "4.38518",
      "4.49807",
    ],
    36: [
      "3.09939",
      "3.28331",
      "3.34694",
      "3.42121",
      "3.50256",
      "3.58478",
      "3.72512",
      "3.75414",
      "3.85046",
      "3.94394",
      "4.03310",
      "4.39707",
      "4.51856",
      "4.63739",
      "4.75563",
      "4.87644",
    ],
    37: [
      "3.43492",
      "3.63971",
      "3.70662",
      "3.78707",
      "3.87023",
      "3.95448",
      "4.09795",
      "4.11832",
      "4.21335",
      "4.30364",
      "4.39171",
      "4.77979",
      "4.90444",
      "5.02825",
      "5.15456",
      "5.28612",
    ],
    38: [
      "3.81268",
      "4.03440",
      "4.10593",
      "4.18625",
      "4.27076",
      "4.35459",
      "4.49639",
      "4.50572",
      "4.59627",
      "4.68482",
      "4.77313",
      "5.18633",
      "5.31596",
      "5.44836",
      "5.58611",
      "5.72864",
    ],
    39: [
      "4.22373",
      "4.46678",
      "4.53509",
      "4.61501",
      "4.69786",
      "4.77839",
      "4.91537",
      "4.94564",
      "4.99723",
      "5.08546",
      "5.17438",
      "5.61597",
      "5.75428",
      "5.89885",
      "6.04857",
      "6.20663",
    ],
    40: [
      "4.67212",
      "4.92829",
      "4.99311",
      "5.06896",
      "5.14641",
      "5.22256",
      "5.35014",
      "5.39665",
      "5.41673",
      "5.50461",
      "5.59587",
      "6.07203",
      "6.22277",
      "6.37994",
      "6.54645",
      "6.71895",
    ],
    41: [
      "5.14403",
      "5.41394",
      "5.47108",
      "5.53856",
      "5.60960",
      "5.67809",
      "5.79973",
      "5.86162",
      "5.89093",
      "5.94245",
      "6.03972",
      "6.55584",
      "6.72009",
      "6.89487",
      "7.07695",
      "7.26584",
    ],
    42: [
      "5.63431",
      "5.91412",
      "5.95856",
      "6.01686",
      "6.07784",
      "6.14159",
      "6.26220",
      "6.33947",
      "6.37117",
      "6.39975",
      "6.50756",
      "7.06555",
      "7.24938",
      "7.44060",
      "7.64035",
      "7.84555",
    ],
    43: [
      "6.13145",
      "6.41594",
      "6.44736",
      "6.49238",
      "6.54730",
      "6.60928",
      "6.73262",
      "6.82180",
      "6.85591",
      "6.87865",
      "6.99760",
      "7.60554",
      "7.80757",
      "8.01813",
      "8.23558",
      "8.45888",
    ],
    44: [
      "6.62976",
      "6.91841",
      "6.93161",
      "6.96846",
      "7.02095",
      "7.08268",
      "7.21235",
      "7.30645",
      "7.34298",
      "7.38108",
      "7.51742",
      "8.17620",
      "8.39950",
      "8.62963",
      "8.86678",
      "9.11244",
    ],
    45: [
      "6.75849",
      "7.04080",
      "7.05002",
      "7.08708",
      "7.14054",
      "7.20597",
      "7.38733",
      "7.45614",
      "7.48188",
      "7.62691",
      "7.78473",
      "8.48693",
      "8.73505",
      "8.98976",
      "9.25270",
      "9.52661",
    ],
    46: [
      "7.19837",
      "7.48979",
      "7.49621",
      "7.53375",
      "7.59226",
      "7.66869",
      "7.87371",
      "7.93592",
      "8.00079",
      "8.16547",
      "8.34412",
      "9.10420",
      "9.37732",
      "9.65947",
      "9.95237",
      "10.25447",
    ],
    47: [
      "7.62097",
      "7.93016",
      "7.93780",
      "7.98215",
      "8.05459",
      "8.14912",
      "8.38275",
      "8.42906",
      "8.55137",
      "8.73957",
      "8.93975",
      "9.76284",
      "10.06703",
      "10.38234",
      "10.70682",
      "11.03815",
    ],
    48: [
      "8.04096",
      "8.37155",
      "8.38802",
      "8.44985",
      "8.54445",
      "8.65855",
      "8.93410",
      "8.94719",
      "9.14658",
      "9.35921",
      "9.58298",
      "10.47895",
      "10.82026",
      "11.17009",
      "11.52745",
      "11.89585",
    ],
    49: [
      "8.47676",
      "8.83780",
      "8.87526",
      "8.96364",
      "9.08109",
      "9.22365",
      "9.54295",
      "9.57611",
      "9.80205",
      "10.04075",
      "10.29341",
      "11.27267",
      "11.65205",
      "12.03800",
      "12.43639",
      "12.84275",
    ],
    50: [
      "8.94616",
      "9.35419",
      "9.42307",
      "9.53775",
      "9.68819",
      "9.85608",
      "10.22594",
      "10.27690",
      "10.53144",
      "10.80126",
      "11.08933",
      "12.15686",
      "12.57525",
      "13.00691",
      "13.44686",
      "13.89298",
    ],
    51: [
      "9.50166",
      "9.96955",
      "10.06601",
      "10.21721",
      "10.39429",
      "10.58962",
      "11.00937",
      "11.07731",
      "11.36467",
      "11.67162",
      "11.99456",
      "13.15673",
      "13.62437",
      "14.10151",
      "14.58459",
      "15.06324",
    ],
    52: [
      "10.16238",
      "10.68839",
      "10.82473",
      "11.00367",
      "11.20893",
      "11.42925",
      "11.89991",
      "11.98836",
      "12.31464",
      "12.65896",
      "13.01619",
      "14.29029",
      "14.80810",
      "15.33227",
      "15.85071",
      "16.35574",
    ],
    53: [
      "10.93471",
      "11.53912",
      "11.70270",
      "11.91048",
      "12.13970",
      "12.38547",
      "12.91334",
      "13.02580",
      "13.39109",
      "13.77184",
      "14.17315",
      "15.56816",
      "16.13790",
      "16.70049",
      "17.24759",
      "17.77070",
    ],
    54: [
      "11.86590",
      "12.53560",
      "12.72547",
      "12.95519",
      "13.20771",
      "13.48405",
      "14.07634",
      "14.20816",
      "14.61150",
      "15.03891",
      "15.48431",
      "17.01119",
      "17.62267",
      "18.21615",
      "18.78260",
      "19.31378",
    ],
    55: [
      "12.95489",
      "13.69369",
      "13.89966",
      "14.14970",
      "14.43121",
      "14.74437",
      "15.69106",
      "16.11128",
      "16.56098",
      "17.03259",
      "17.52417",
      "19.21765",
      "19.86394",
      "20.48072",
      "21.05974",
      "21.60001",
    ],
  },
};
